// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";
import { TrackEventBaseParameters } from "@store/Framework/Common/GoogleAnalytics/trackers/trackEvent";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackFormStartParameters extends TrackEventBaseParameters<null, "form_name"> {}

const trackFormStart = (parameters: TrackFormStartParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.event({ action: "start_form", ...parameters }, options);
};

export default trackFormStart;
